// @mui
import { styled } from '@mui/material/styles';
import { Typography, Card, CardContent, CardProps, IconButton, Tooltip } from '@mui/material';
import HighlightOff from '@mui/icons-material/HighlightOff';
import WelcomeIllustration from 'src/assets/illustration_welcome';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  backgroundColor: theme.palette.primary.lighter,
  [theme.breakpoints.up('md')]: {
    height: '100%',
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
  },
}));

// ----------------------------------------------------------------------

interface AppWelcomeProps extends CardProps {
  displayName?: string;
  onClose?: () => void;
}

const DashboardGreeting = ({ displayName, onClose }: AppWelcomeProps) => (
  <RootStyle>
    <CardContent
      sx={{
        p: { md: 0 },
        pl: { md: 5 },
        color: 'grey.800',
      }}
    >
      {onClose && (
        <Tooltip title="Hide greeting">
          <IconButton
            aria-label="close"
            size="small"
            sx={{ position: 'absolute', top: 7.5, left: 7.5, color: 'black' }}
            onClick={onClose}
          >
            <HighlightOff fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
      <Typography gutterBottom variant="h4">
        Welcome {!displayName ? '...' : `${displayName}!`}
      </Typography>

      <Typography variant="body2" sx={{ pb: { xs: 3, xl: 5 }, maxWidth: 480, mx: 'auto' }}>
        We're glad you're here.
        <br />
        <br />
        We strive to constantly improve our product. You can talk to us through the chat widget at
        the bottom to request new features or ask us any questions you might have!
      </Typography>

      {/* <Button variant="contained" to="#" component={RouterLink}>
          Go Now
        </Button> */}
    </CardContent>

    <WelcomeIllustration
      sx={{
        p: 3,
        width: 360,
        margin: { xs: 'auto', md: 'inherit' },
      }}
    />
  </RootStyle>
);

export default DashboardGreeting;
